import { render, staticRenderFns } from "./instructListDetail.vue?vue&type=template&id=08760b34&"
import script from "./instructListDetail.vue?vue&type=script&lang=js&"
export * from "./instructListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08760b34')) {
      api.createRecord('08760b34', component.options)
    } else {
      api.reload('08760b34', component.options)
    }
    module.hot.accept("./instructListDetail.vue?vue&type=template&id=08760b34&", function () {
      api.rerender('08760b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/instruct/instructListDetail.vue"
export default component.exports